import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/Users.vue'),
      },
      {
        path: 'kyc',
        name: 'kyc',
        component: () => import('@/views/KYC.vue'),
      },
      {
        path: 'assets',
        name: 'assets',
        component: () => import('@/views/Assets.vue'),
      },
      {
        path: 'withdrawals',
        name: 'withdrawals',
        component: () => import('@/views/Withdrawals.vue'),
      },
      {
        path: 'audit-logs',
        name: 'audit-logs',
        component: () => import('@/views/AuditLogs.vue'),
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('@/views/Roles.vue'),
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/Settings.vue'),
      },
      {
        path: 'token-splits',
        name: 'token-splits',
        component: () => import('@/views/TokenSplits.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // Check for token in localStorage as well (in case store wasn't initialized yet)
  const hasToken = authStore.token || localStorage.getItem('admin_token');

  if (to.meta.requiresAuth && !hasToken) {
    next({ name: 'login' });
    return;
  }

  if (to.name === 'login' && hasToken) {
    next({ name: 'dashboard' });
    return;
  }

  next();
});

export default router;
